import axios from 'axios';

let $http = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'X-Requested-With' : 'XMLHttpRequest'
    },
    withCredentials: false,
    crossDomain: true,
    params: {}
});

const HttpService = {
    install(Vue) {
        Vue.prototype.$httpService = $http;
    }
};

export default (HttpService);